// removed by extract-text-webpack-plugin
module.exports = {"inputField":"inputField___1KD_D","inputLabel":"inputLabel___3L9He","container":"container___23KLf","required":"required___EjRxo","multiSelect":"multiSelect___2m-RN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImportForm/ImportForm.module.css
// module id = 216
// module chunks = 0